/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1PersonIdPhotoQueryResponse,
  GetApiV1PersonIdPhotoPathParams,
  GetApiV1PersonIdPhoto401,
  GetApiV1PersonIdPhoto404,
  GetApiV1PersonIdPhoto500,
} from "../../types/personRegisterController/GetApiV1PersonIdPhoto.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1PersonIdPhoto } from "../../clients/personRegisterController/getApiV1PersonIdPhoto.ts";

export const getApiV1PersonIdPhotoQueryKey = (
  id: GetApiV1PersonIdPhotoPathParams["id"],
) => [{ url: "/api/v1/person/:id/photo", params: { id: id } }] as const;

export type GetApiV1PersonIdPhotoQueryKey = ReturnType<
  typeof getApiV1PersonIdPhotoQueryKey
>;

export function getApiV1PersonIdPhotoQueryOptions(
  id: GetApiV1PersonIdPhotoPathParams["id"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1PersonIdPhotoQueryKey(id);
  return queryOptions<
    GetApiV1PersonIdPhotoQueryResponse,
    ResponseErrorConfig<
      | GetApiV1PersonIdPhoto401
      | GetApiV1PersonIdPhoto404
      | GetApiV1PersonIdPhoto500
    >,
    GetApiV1PersonIdPhotoQueryResponse,
    typeof queryKey
  >({
    enabled: !!id,
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1PersonIdPhoto(id, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna a foto de perfil da pessoa. **(Requer Authorization para autenticação)**
 * @summary Obter foto de perfil (Requer Authorization para autenticação)
 * {@link /api/v1/person/:id/photo}
 */
export function useGetApiV1PersonIdPhoto<
  TData = GetApiV1PersonIdPhotoQueryResponse,
  TQueryData = GetApiV1PersonIdPhotoQueryResponse,
  TQueryKey extends QueryKey = GetApiV1PersonIdPhotoQueryKey,
>(
  id: GetApiV1PersonIdPhotoPathParams["id"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1PersonIdPhotoQueryResponse,
        ResponseErrorConfig<
          | GetApiV1PersonIdPhoto401
          | GetApiV1PersonIdPhoto404
          | GetApiV1PersonIdPhoto500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ?? getApiV1PersonIdPhotoQueryKey(id);

  const query = useQuery(
    {
      ...getApiV1PersonIdPhotoQueryOptions(id, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1PersonIdPhoto401
      | GetApiV1PersonIdPhoto404
      | GetApiV1PersonIdPhoto500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
